<script lang="ts">
import Vue from 'vue';
import { updateTariff } from '@/api/organizations/tariffs';
import Card from '@/components/ui/Card.vue';
import Checkbox from '@/components/ui/Checkbox.vue';

export default Vue.extend({
  name: 'TariffOsagoItem',
  components: { Checkbox, Card },
  props: {
    tariff: {
      type: Object,
    },
  },
  methods: {
    updateTariff() {
      updateTariff(this.tariff.id, { isActive: this.tariff.isActive }).then(() => {
        this.$emit('update:tariff', this.tariff);
      });
    },
  }
});
</script>

<template>
    <div class="card-wrapper">
        <Card class="card">
            <div class="tariff-item d-flex justify-content-between flex-row align-items-center">
                <div class="column">
                    <div class="head">Тип продукту</div>
                    <div class="d-flex">
                        <div class="mr-2">
                            <Checkbox v-model="tariff.isActive" @change="updateTariff"></Checkbox>
                        </div>
                        <div>
                            ОСЦПВ
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="head">Тип користувача</div>
                    <div>{{ $store.getters.CUSTOMER_TYPES.filter(t => tariff.parameters.userTypes.includes(t.id)).map(t => t.value).join(', ') }}
                    </div>
                </div>
                <!--            <div class="column">-->
                <!--                <div class="head">ОТК</div>-->
                <!--                <div>test</div>-->
                <!--            </div>-->
                <div class="column">
                    <div class="head">Комісія, %</div>
                    <div>{{ tariff.commission }}</div>
                </div>
                <div class="column">
                    <div class="head">Зона реєстрації ТЗ</div>
                    <div>{{ tariff.parameters.osagoZones.join(', ') }}</div>
                </div>
                <div class="column">
                    <div class="head">Тип ТЗ</div>
                    <div>{{ tariff.parameters.autoCategoryTypes.join(', ') }}</div>
                </div>
                <div class="column">
                    <div class="head">Программа</div>
                    <div>{{ tariff.parameters.programms ? tariff.parameters.programms.join(', ') : 1 }}</div>
                </div>
            </div>
        </Card>
    </div>
</template>

<style scoped lang="scss">
.card {
    &-wrapper {
        overflow: scroll;
    }

    min-width: 800px;
}

.tariff-item {
    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

    font-family: Inter, serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */

    color: #09090B;

    .column {
        /* Frame 1000005970 */

        /* Auto layout */
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 16px;

        margin: 0 auto;

        /* Inside auto layout */
        flex: 1 1 0;
        order: 1;
        align-self: stretch;
        /*flex-grow: 1;*/

        .head {
            /* Text */

            /* Text xs / Semibold */
            font-family: 'Inter', serif;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
            /* identical to box height, or 150% */

            /* Gray/500 */
            color: #717680;


            /* Inside auto layout */
            flex: none;
            order: 0;
            flex-grow: 0;

        }
    }
}
</style>

